export default "__VITE_ASSET__quEel90K__"